export default __webpack_public_path__ + "static/media/Círculo_Carcajadas__1_-removebg-preview.84a5c95b.png";